import React from 'react'
import { Typography } from '@mui/material'

import { textFiles } from 'constants/textFiles'
import useTranslation from 'hooks/useTranslation'

import Logo from 'images/LogoCurbo.svg'
import MiniChopperImage from 'images/MiniChopper.png'

import {
  StyledContent,
  StyledImageContainer,
  StyledLayout,
  StyledLeftContainer,
  StyledRightContainer,
} from './style'

const AuthLayout: React.FC = ({ children }) => {
  const { text } = useTranslation(textFiles.AUTH)

  return (
    <StyledLayout>
      <StyledLeftContainer>
        <StyledContent>
          <img alt="Curbo Logo" src={Logo} />
          <Typography sx={{ fontSize: 80, marginTop: '5rem' }} variant="h1">
            {text.welcomeMessage}
          </Typography>
          <Typography variant="h5">{text.helpMessage}</Typography>
          <StyledImageContainer>
            <img alt="Mini chopper" src={MiniChopperImage} />
          </StyledImageContainer>
        </StyledContent>
      </StyledLeftContainer>
      <StyledRightContainer>{children}</StyledRightContainer>
    </StyledLayout>
  )
}

export default AuthLayout
